import { InputType } from './input';
import { DEFAULT_COUNTRY_CODE } from './phone';

import { getInputProps } from 'src/utils/get-input-props';

export const InitialContactRequestValues = {
  email: getInputProps(InputType.EMAIL, true),
  message: getInputProps(InputType.MESSAGE, true),
  name: getInputProps(InputType.NAME, true),
  phone: getInputProps(InputType.PHONE, true),
  countryCode: getInputProps(InputType.COUNTRY_CODE, false, DEFAULT_COUNTRY_CODE),
};
